import { BigNumber } from 'bignumber.js';

export const MAX_NUM = new BigNumber('18446744073709551615');
